import { useMemo } from "react";
import { useAccountSettings } from "@/entities/settings/hooks";
import { parseFiscalYearStartMonth } from "@/entities/settings/fiscalYear";

/**
 * The account's fiscal year start as a 0-indexed month. January is the same
 * fallback the backend's PeriodCalculator applies when the setting is unset.
 */
export const useFiscalYearStartMonth = (): number => {
  const { data: accountSettings } = useAccountSettings();
  return useMemo(() => {
    const raw = accountSettings?.find(
      (setting) => setting.key === "fiscal_year_start"
    )?.value;
    return (
      parseFiscalYearStartMonth(typeof raw === "string" ? raw : undefined) ?? 0
    );
  }, [accountSettings]);
};
